import AssetReadinessStatuses from "./AssetReadinessStatuses";

export default AssetReadinessStatuses;